// extracted by mini-css-extract-plugin
module.exports = {"container":"FooterView_container__28TRc","linkContainer":"FooterView_linkContainer__2vt-B"};